import React, { useContext } from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';
import { observer } from 'mobx-react';
import { Col, PageHeader, Row } from 'react-bootstrap';
import ViewLoader from '../../Loading/View';
import { storesContext } from '../../../stores';

const GenericViewError = () => {
  const { t } = useTranslation();
  const { routerStore } = useContext(storesContext);
  const title = routerStore?.route?.params?.title;

  return (
    <>
      <Helmet title={`${t(title)} - Red Hat Learning`} />
      <div className="container-grid-responsive">
        <PageHeader>{t(title)}</PageHeader>
        <React.Suspense fallback={<ViewLoader />}>
          <Row>
            <Col sm={12}>{t("We're having trouble displaying this page.")}</Col>
          </Row>
        </React.Suspense>
      </div>
    </>
  );
};

export default observer(GenericViewError);
